import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { t } from 'i18next';
const Navbar = ({
  startSlot,
  endSlot,
  logo = "img/Co-logos/logo.png",
  companyName = "Alrawabit",
}) => {
  const {  i18n } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const isRTL = i18n.language === 'ar';
  
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    } else {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    }
    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);
  
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
  };
  
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleLanguageMenu = () => {
    setIsLanguageMenuOpen(!isLanguageMenuOpen);
  };

  const closeLanguageMenu = () => {
    setIsLanguageMenuOpen(false);
  };

  const handleLanguageChange = (lng) => {
    changeLanguage(lng);
    closeLanguageMenu();
  };

  return (
    <header
      className={`navbar-header ${isScrolled ? 'scrolled' : ''} ${isRTL ? 'rtl' : 'ltr'}`}
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <nav className="navbar-container">
        <div className="navbar-start">
          <div className="navbar-brand">
            <a href="/" className="logo-link">
              <img
                src={logo}
                alt={companyName}
                className="logo-image"
              />
              <span className="company-name">{companyName}</span>
            </a>
          </div>
          {startSlot && (
            <div className="start-slot">
              {startSlot}
            </div>
          )}
        </div>
        
        <div className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <div className="nav-links">
            <a href="#home" className="nav-link" onClick={closeMobileMenu}>
              <span>{t('home')}</span>
            </a>

            <a href="#about" className="nav-link" onClick={closeMobileMenu}>
              <span style={{ minWidth: '60px' }}>{t('about')}</span>
            </a>
            <a href="#products" className="nav-link" onClick={closeMobileMenu}>
              {t('products')}
            </a>
            <a href="#store" className="nav-link" onClick={closeMobileMenu}>
              <span>{t('store')}</span>
            </a>
            <a href="#contact" className="nav-link" onClick={closeMobileMenu}>
              <span>{t('contact')}</span>
            </a>
          </div>
        </div>
        
        <div className="navbar-end">
          <div className="language-switcher">
            <button
              className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`}
              onClick={() => changeLanguage('en')}
            >
              EN
            </button>
            <button
              className={`lang-btn ${i18n.language === 'ar' ? 'active' : ''}`}
              onClick={() => changeLanguage('ar')}
            >
              AR
            </button>
            <button
              className={`lang-btn ${i18n.language === 'zh' ? 'active' : ''}`}
              onClick={() => changeLanguage('zh')}
            >
              中
            </button>
          </div>
          
          {endSlot && (
            <div className="end-slot">
              {endSlot}
            </div>
          )}
          
          <div className="mobile-controls">
            <button
              className="mobile-language-toggle"
              onClick={toggleLanguageMenu}
              aria-label={t('change_language')}
            >
              <FontAwesomeIcon icon={faGlobe} className="text-primary" />
            </button>
            
            {isLanguageMenuOpen && (
              <div className="mobile-language-dropdown">
                <button
                  className={`mobile-lang-item ${i18n.language === 'en' ? 'active' : ''}`}
                  onClick={() => handleLanguageChange('en')}
                >
                  {t('english')}
                </button>
                <button
                  className={`mobile-lang-item ${i18n.language === 'ar' ? 'active' : ''}`}
                  onClick={() => handleLanguageChange('ar')}
                >
                  {t('arabic')}
                </button>
                <button
                  className={`mobile-lang-item ${i18n.language === 'zh' ? 'active' : ''}`}
                  onClick={() => handleLanguageChange('zh')}
                >
                  {t('chinese')}
                </button>
              </div>
            )}
            
            <button
              className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
        
        {isMobileMenuOpen && (
          <div
            className="mobile-overlay"
            onClick={closeMobileMenu}
          ></div>
        )}
        
        {isLanguageMenuOpen && (
          <div
            className="language-overlay"
            onClick={closeLanguageMenu}
          ></div>
        )}
      </nav>
    </header>
  );
};

export default Navbar;